import { render } from "./ValidarIdentidad.vue?vue&type=template&id=0799d99e"
import script from "./ValidarIdentidad.vue?vue&type=script&lang=js"
export * from "./ValidarIdentidad.vue?vue&type=script&lang=js"

import "./ValidarIdentidad.vue?vue&type=style&index=0&id=0799d99e&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__